module.exports = __webpack_public_path__ + "img/email-share-icon.92e5a801.svg";